import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquareText, FileText } from "lucide-react";
import { TEL_HREF, SMS_HREF } from "@/data/site";

export default function MobileActionBar() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let last = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const doc = document.documentElement;
        const atBottom = window.innerHeight + y >= doc.scrollHeight - 90;
        if (atBottom || y < 80) setHidden(false);
        else if (y > last + 6) setHidden(true); // scrolling down -> get out of the way
        else if (y < last - 6) setHidden(false); // scrolling up -> come back
        last = y;
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`xl:hidden fixed bottom-0 left-0 right-0 z-40 bg-ink/95 backdrop-blur-md border-t border-gold/30 transition-transform duration-300 ${
        hidden ? "translate-y-full" : "translate-y-0"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-action-bar"
    >
      <div className="grid grid-cols-3 divide-x divide-white/10">
        <a
          href={TEL_HREF}
          className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/5"
          data-testid="action-call"
        >
          <Phone size={19} strokeWidth={1.75} aria-hidden="true" />
          <span className="text-[0.68rem] font-semibold tracking-wide">Call</span>
        </a>
        <a
          href={SMS_HREF}
          className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/5"
          data-testid="action-text"
        >
          <MessageSquareText size={19} strokeWidth={1.75} aria-hidden="true" />
          <span className="text-[0.68rem] font-semibold tracking-wide">Text</span>
        </a>
        <Link
          to="/free-estimate"
          className="flex flex-col items-center justify-center gap-1 py-3 bg-blush text-ink font-semibold active:brightness-95"
          data-testid="action-estimate"
        >
          <FileText size={19} strokeWidth={1.75} aria-hidden="true" />
          <span className="text-[0.68rem] tracking-wide">Free Estimate</span>
        </Link>
      </div>
    </div>
  );
}
